<!--
 * @Description: 粉煤灰模板
 * @Autor: yjx
 * @Date: 2021-11-16 15:24:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 17:04:51
-->
<template>
  <div id="template2" class="template_table_parent">
    <table class="template_table" border="1" cellpadding="0" cellspacing="0" @change="getChanges">
      <tr>
        <td colspan="8"></td>
        <td>检测编号:</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.code }}</td>
      </tr>
      <tr>
        <td>委托单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_01 }}</td>
        <td>品 种</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_02 }}</td>
        <td>出厂编号</td>
        <td :class="{ bg5: !isViewResult }">
          <el-input v-model="formData.cell_03.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>取样日期</td>
        <td :class="{ bg3: !isViewResult }" class="select_date" colspan="2">{{ defaultData.cell_04 }}</td>
      </tr>
      <tr>
        <td>检测单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_05 }}</td>
        <td>等 级</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_06 }}</td>
        <td>车 牌 号</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_07 }}</td>
        <td>试验日期</td>
        <td :class="{ bg3: !isViewResult }" class="select_date" colspan="2">
          <el-date-picker v-model="formData.cell_08.resultValue" type="datetime" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"> </el-date-picker>
        </td>
      </tr>
      <tr>
        <td>生产厂家</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_09 }}</td>
        <td>品 牌</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_10 }}</td>
        <td>环境温度</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_11.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>代表批量</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_12 }}</td>
      </tr>
      <tr>
        <td>送货单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_10 }}</td>
        <td>样品来源</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_10 }}</td>
        <td>环境湿度</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_15.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>检测依据</td>
        <td :class="{ bg4: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_16.resultValue" placeholder="请输入" disabled :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>进场验收项目</td>
        <td>材质证明</td>
        <td :class="formData.cell_17.clsObj">
          <el-select v-model="formData.cell_17.resultValue" value-key="id" :readonly="isViewResult">
            <el-option v-for="item in formData.cell_17.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td>颜色对比</td>
        <td :class="formData.cell_18.clsObj">
          <el-select v-model="formData.cell_18.resultValue" value-key="id" :readonly="isViewResult">
            <el-option v-for="item in formData.cell_18.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td>含石粉量</td>
        <td :class="formData.cell_19.clsObj">
          <el-select v-model="formData.cell_19.resultValue" value-key="id" :readonly="isViewResult">
            <el-option v-for="item in formData.cell_19.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td>含油量</td>
        <td :class="formData.cell_20.clsObj">
          <el-select v-model="formData.cell_20.resultValue" value-key="id" :readonly="isViewResult">
            <el-option v-for="item in formData.cell_20.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td>品种类型</td>
        <td :class="formData.cell_21.clsObj">
          <el-select v-model="formData.cell_21.resultValue" value-key="id" :readonly="isViewResult">
            <el-option v-for="item in formData.cell_21.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td>项目</td>
        <td>含水量（%）</td>
        <td>密度（g/cm³）</td>
        <td>安定性（雷氏增加）</td>
        <td>比表面积（m²/kg）</td>
        <td colspan="2">三氧化硫含量（%）</td>
        <td colspan="2">松散堆积密度（kg/m³）</td>
        <td colspan="2">净浆流动度（mm）</td>
      </tr>
      <tr>
        <td>测定值</td>
        <td @click="setData('cell_22')">{{ formData.cell_22_p03.resultValue || "请配置" }}</td>
        <td @click="setData('cell_23')">{{ formData.cell_23_p04.resultValue || "请配置" }}</td>
        <td @click="setData('cell_24')">{{ formData.cell_24_p01.resultValue || "请配置" }}</td>
        <td>
          <el-input v-model="formData.cell_25.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="2" @click="setData('cell_26')">{{ formData.cell_26_p04.resultValue || "请配置" }}</td>
        <td colspan="2">
          <el-input v-model="formData.cell_27.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="2">
          <el-input v-model="formData.cell_28.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td rowspan="2">需水量比</td>
        <td>基准用水量（mm）</td>
        <td>粉煤灰用水量（mm）</td>
        <td colspan="2">测定值</td>
        <td>胶砂加水时间</td>
        <td colspan="2" :class="{ bg3: !isViewResult }" class="select_date">
          <el-date-picker v-model="formData.cell_32.resultValue" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"> </el-date-picker>
        </td>
        <td>基准水泥强度（Mpa）</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">{{ formData.cell_33.resultValue }}</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_29.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_30.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_31.clsObj" colspan="2">
          {{ formData.cell_31.resultValue }}
          <el-tooltip v-if="formData.cell_31.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_31.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td rowspan="8">28天活性指数（Mpa）</td>
        <td colspan="2" rowspan="2">强度（Mpa）</td>
        <td rowspan="2">强度平均值（Mpa）</td>
        <td colspan="2" rowspan="2">活性指数（%）</td>
      </tr>
      <tr>
        <td rowspan="3">45μm筛余</td>
        <td>试样重（g）</td>
        <td>筛余重（g）</td>
        <td>筛余测定值（%）</td>
        <td>细度（45μm筛余）</td>
      </tr>
      <tr>
        <td :class="{ bg4: !isViewResult }">
          <el-input v-model="formData.cell_34.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_35.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_36.clsObj">
          {{ formData.cell_36.resultValue }}
          <el-tooltip v-if="formData.cell_36.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_36.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td :class="{ bg1: !isViewResult }" rowspan="2">{{ formData.cell_53.resultValue }}</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_45.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }" rowspan="6">{{ formData.cell_51.resultValue }}</td>
        <td :class="formData.cell_52.clsObj" colspan="2" rowspan="6">
          {{ formData.cell_52.resultValue }}
          <el-tooltip v-if="formData.cell_52.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_52.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
      </tr>
      <tr>
        <td :class="{ bg4: !isViewResult }">
          <el-input v-model="formData.cell_37.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_38.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_39.clsObj">
          {{ formData.cell_39.resultValue }}
          <el-tooltip v-if="formData.cell_39.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_39.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_46.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td rowspan="2">烧矢量</td>
        <td>试样重（g）</td>
        <td>坩埚重（g）</td>
        <td>烧后坩埚+样重（g）</td>
        <td>烧矢量（%）</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_47.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_40.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_41.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_42.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_43.clsObj">
          {{ formData.cell_43.resultValue }}
          <el-tooltip v-if="formData.cell_43.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_43.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_48.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td rowspan="2">备 注</td>
        <td colspan="4" rowspan="2">
          <el-input v-model="formData.cell_44.resultValue" type="textarea" :rows="2" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_49.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_50.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td></td>
        <td>审核：</td>
        <td :class="{ bg5: !isViewResult }" colspan="3">{{ defaultData.reviewer }}</td>
        <td></td>
        <td>试验：</td>
        <td :class="{ bg5: !isViewResult }" colspan="3">
          {{ user.inspector.label }}
          <!--                    <el-select v-model="tester" filterable value-key="value" placeholder="请选择">-->
          <!--                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item"></el-option>-->
          <!--                    </el-select>-->
        </td>
        <td></td>
      </tr>
    </table>

    <SetPopupDialog :visible.sync="popupVisible" :config="popupConfig" @updated="updated" @formChange="changeFun" />
  </div>
</template>
<script>
import SetPopupDialog from "../SetPopupDialog";
// import { getUsetListByPermission } from "@/api/index.js"

const dataArr = {
  cell_03: { resultValue: "", key: "ccbh", title: "出场编号", category: 3, type: 3, code: "cell_03" },
  cell_08: { resultValue: "", key: "syrq", title: "试验日期", category: 3, type: 3, code: "cell_08" },
  cell_11: { resultValue: "", key: "hjwd", title: "环境温度", category: 3, type: 3, code: "cell_11" },
  cell_15: { resultValue: "", key: "hjsd", title: "环境湿度", category: 3, type: 3, code: "cell_15" },
  cell_17: {
    resultValue: "",
    title: "材质证明",
    category: 7,
    type: 1,
    options: [
      { id: 0, label: "齐全且一致" },
      { id: 1, label: "不齐全或不一致" },
    ],
    clsObj: { bg5: true },
  },
  cell_18: {
    resultValue: "",
    title: "颜色对比",
    category: 7,
    type: 1,
    options: [
      { id: 0, label: "相邻批次一致" },
      { id: 1, label: "相邻批次不一致" },
    ],
    clsObj: { bg5: true },
  },
  cell_19: {
    resultValue: "",
    title: "含石粉量",
    category: 7,
    type: 1,
    options: [
      { id: 0, label: "草酸检测无明显气泡" },
      { id: 1, label: "草酸检测有气泡" },
    ],
    clsObj: { bg5: true },
  },
  cell_20: {
    resultValue: "",
    title: "含油量",
    category: 7,
    type: 1,
    options: [
      { id: 0, label: "水面无油污" },
      { id: 1, label: "水面有油污" },
    ],
    clsObj: { bg5: true },
  },
  cell_21: {
    resultValue: "",
    title: "品种类型",
    category: 7,
    type: 1,
    options: [
      { id: 0, label: "与合同一致" },
      { id: 1, label: "与合同不一致" },
    ],
    clsObj: { bg5: true },
  },
  cell_16: { resultValue: "GB/T 1596－2017", key: "jcyj", title: "检测依据", category: 6, type: 2, code: "cell_16", default: "JGJ52 - 2006" },
  cell_22_p01: { unit: "g", valType: "input", resultValue: "", key: "hgqsyzl", title: "烘干前试样质量", category: 2, type: 3, code: "cell_22_p01" },
  cell_22_p02: { unit: "g", valType: "input", resultValue: "", key: "hghsyzl", title: "烘干后试样质量", category: 2, type: 3, code: "cell_22_p02" },
  cell_22_p03: { unit: "%", valType: "calc", resultValue: "", key: "hsl", title: "含水量", category: 2, type: 3, code: "cell_22_p03", clsObj: { bg2: true } },
  cell_23_p01: { unit: "g", valType: "input", resultValue: "", key: "mdsyz", title: "试样重", category: 2, type: 3, code: "cell_23_p01" },
  cell_23_p02: { unit: "g", valType: "input", resultValue: "", key: "mddyckd", title: "第一次刻度", category: 2, type: 3, code: "cell_23_p02" },
  cell_23_p03: { unit: "g", valType: "input", resultValue: "", key: "mddeckd", title: "第二次刻度", category: 2, type: 3, code: "cell_23_p03" },
  cell_23_p04: { unit: "%", valType: "calc", resultValue: "", key: "md", title: "密度", category: 2, type: 3, code: "cell_23_p04", clsObj: { bg2: true } },
  cell_24_p01: { unit: "mm", valType: "input", resultValue: "", key: "adx", title: "安定性", category: 2, type: 3, code: "cell_24_p01", clsObj: { bg2: true } },
  cell_25: { resultValue: "", key: "bbmj", title: "比表面积", category: 2, type: 3, code: "cell_25", clsObj: { bg2: true } },
  cell_26_p01: { unit: "g", valType: "input", resultValue: "", key: "syhlkggz", title: "空坩埚重", category: 2, type: 3, code: "cell_26_p01" },
  cell_26_p02: { unit: "g", valType: "input", resultValue: "", key: "syhlsyz", title: "试样重", category: 2, type: 3, code: "cell_26_p02" },
  cell_26_p04: { unit: "%", valType: "calc", resultValue: "", key: "syhlhl", title: "三氧化硫含量", category: 2, type: 3, code: "cell_26_p04", clsObj: { bg2: true } },
  cell_26_p03: { unit: "g", valType: "input", resultValue: "", key: "syhlzshzz", title: "灼烧后总重", category: 2, type: 3, code: "cell_26_p03" },
  cell_27: { resultValue: "", key: "ssdjmd", title: "松散堆积密度", category: 5, type: 3, code: "cell_27" },
  cell_28: { resultValue: "", key: "jjldd", title: "净浆流动度", category: 5, type: 3, code: "cell_28" },
  cell_29: { resultValue: "", key: "jzysl", title: "基准用水量", category: 3, type: 3, code: "cell_29" },
  cell_30: { resultValue: "", key: "syysl", title: "试验用水量", category: 3, type: 3, code: "cell_30" },
  cell_32: { resultValue: "", key: "jsjssj", title: "胶砂加水时间", category: 3, type: 3, code: "cell_32" },
  cell_33: { resultValue: "", key: "jzsnqd", title: "基准水泥强度", category: 3, type: 1, code: "cell_33" },
  cell_34: { resultValue: "10", key: "sysyz1", title: "筛余试样重", category: 3, type: 3, code: "cell_34" },
  cell_37: { resultValue: "10", key: "sysyz2", title: "筛余试样重", category: 3, type: 3, code: "cell_37" },
  cell_35: { resultValue: "", key: "syz", title: "筛余重", category: 3, type: 3, code: "cell_35" },
  cell_38: { resultValue: "", key: "syz", title: "筛余重", category: 3, type: 3, code: "cell_38" },
  cell_43: { resultValue: "", key: "ssl", title: "烧矢量", category: 1, type: 3, code: "cell_43", clsObj: { bg1: true } },
  cell_40: { resultValue: "", key: "sslsyz", title: "烧矢量试样重", category: 3, type: 3, code: "cell_40" },
  cell_41: { resultValue: "", key: "sslkggz", title: "烧矢量空坩埚重", category: 3, type: 3, code: "cell_41" },
  cell_42: { resultValue: "", key: "sslzshzz", title: "烧矢量灼烧后总重", category: 3, type: 3, code: "cell_42" },
  cell_44: { resultValue: "", key: "bz", title: "备注", category: 4, type: 2, code: "cell_44" },
  cell_45: { resultValue: "", key: "qd1", title: "强度", category: 3, type: 3, code: "cell_45" },
  cell_46: { resultValue: "", key: "qd2", title: "强度", category: 3, type: 3, code: "cell_46" },
  cell_47: { resultValue: "", key: "qd3", title: "强度", category: 3, type: 3, code: "cell_47" },
  cell_48: { resultValue: "", key: "qd4", title: "强度", category: 3, type: 3, code: "cell_48" },
  cell_49: { resultValue: "", key: "qd5", title: "强度", category: 3, type: 3, code: "cell_49" },
  cell_50: { resultValue: "", key: "qd6", title: "强度", category: 3, type: 3, code: "cell_50" },
  // 以下为计算属性
  cell_31: { resultValue: "", key: "xslbcdz", title: "需水量比测定值", category: 1, type: 3, code: "cell_31", clsObj: { bg1: true } },
  cell_36: { resultValue: "", key: "sycdz1", title: "筛余测定值", category: 1, type: 3, code: "cell_36", clsObj: { bg1: true } },
  cell_39: { resultValue: "", key: "sycdz2", title: "筛余测定值", category: 1, type: 3, code: "cell_39", clsObj: { bg1: true } },
  cell_53: { resultValue: "", key: "xd", title: "细度", category: 1, type: 3, code: "cell_53" },
  cell_51: { resultValue: "", key: "qdpjz", title: "强度平均值", category: 3, type: 3, code: "cell_51" },
  cell_52: { resultValue: "", key: "hxzs", title: "活性指数", category: 1, type: 3, code: "cell_52", clsObj: { bg1: true } },
};

export default {
  components: {
    SetPopupDialog,
  },
  props: {
    defaultData: {
      // 默认基本数据
      type: Object,
      default: () => {},
    },
    saveData: {
      // 保存的数据
      type: Object,
      default: () => {},
    },
    user: {
      // 试验人
      type: Object,
      default: () => {
        return {
          approver: {
            label: "",
          },
          inspector: {
            label: "",
          },
        };
      },
    },
    buttonType: {
      // 点击按钮的类型 save保存 submit提交（会校验必填项）
      type: String,
      default: "",
    },
    isViewResult: {
      // 查看结果还是录入数据
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: null,
      popupVisible: false,
      popupConfig: null,
      options: [],
      curKey: "xx",
    };
  },
  watch: {
    defaultData(val) {
      if(val) {
        this.formData["cell_33"].resultValue = this.defaultData.twentyEightDayAvg;
      }
    }
  },
  created() {
    if (Object.keys(this.saveData).length === 0) {
      this.formData = JSON.parse(JSON.stringify(dataArr));
    } else {
      let form = JSON.parse(JSON.stringify(this.saveData));
      for (let key in dataArr) {
        let item = form[key];
        if (item) {
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }else {
          item = dataArr[key];
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }
      }
      this.formData = form;
      //移动端没有25，这里单独添加
      this.$set(this.formData, "cell_25", dataArr["cell_25"]);
    }
  },
  mounted() {
    // if (Object.keys(this.saveData).length === 0) {
    //   this.formData = JSON.parse(JSON.stringify(dataArr));
    // } else {
    //   let form = JSON.parse(JSON.stringify(this.saveData));
    //   for (let key in dataArr) {
    //     let item = form[key];
    //     if (!item) {
    //       item = dataArr[key];
    //       if (this.isViewResult) {
    //         // 查看，设置查看效果
    //         if (item.clsObj) {
    //           for (let i in item.clsObj) {
    //             item.clsObj[i] = false;
    //           }
    //           if (item.isQualified === 0) {
    //             item.clsObj["red-bg"] = true;
    //           } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
    //             item.clsObj["yellow-bg"] = true;
    //           }
    //         }
    //       }
    //     }
    //   }
    //   this.formData = form;
    //   //移动端没有25，这里单独添加
    //   this.$set(this.formData, "cell_25", dataArr["cell_25"]);
    // }
    //基准水泥强度取最近一条胶砂数据
    this.formData["cell_33"].resultValue = this.defaultData.twentyEightDayAvg;
    for (const key in this.formData) {
      let item = this.formData[key];
      if (item.options && item.resultValue && typeof item.resultValue === "string") {
        console.log(item);
        item.resultValue = JSON.parse(item.resultValue);
      }
    }

    if (this.defaultData) {
      // 处理快检数据
      for (const key in this.defaultData) {
        if (/^cell/.test(key)) {
          let res = this.defaultData[key];
          if (res && this.defaultData.content && this.defaultData.content[key] && this.defaultData.content[key].type === 1) {
            res = JSON.parse(res);
          }
          if (!this.formData[key]) {
            let data = dataArr[key];
            if (!data) {
              data = { resultValue: "", category: 6, type: 1 };
            }
            this.$set(this.formData, key, data);
          }
          if (!this.formData[key].resultValue) {
            this.formData[key].resultValue = res;
          }
        }
      }
      const content = this.defaultData.content;
      if (content) {
        for (const key in content) {
          if (/^cell/.test(key)) {
            if (!this.formData[key]) {
              this.$set(this.formData, key, dataArr[key]);
            }
          }
        }
      }
    }

    // console.log(this.defaultData, this.saveData, dataArr.length)
    console.log(this.formData, this.formData.cell_134);
  },
  methods: {
    getChanges() {
      // 有输入就核算
      let val = "";
      // 需水量比
      if (this.hasValues([29, 30])) {
        val = Math.round((this.getFieldVal(30) / this.getFieldVal(29)) * 100);
      }
      this.setFieldVal(31, val);
      // 45μm筛余
      val = "";
      if (this.hasValues([37, 38])) {
        val = Math.round((this.getFieldVal(38) / this.getFieldVal(37)) * 100);
      }
      this.setFieldVal(39, val);
      val = "";
      if (this.hasValues([34, 35])) {
        val = Math.round((this.getFieldVal(35) / this.getFieldVal(34)) * 100);
      }
      this.setFieldVal(36, val);
      val = "";
      if (this.hasValues([36, 39])) {
        val = ((this.getFieldVal(36) + this.getFieldVal(39)) / 2).toFixed(1);
      }
      this.setFieldVal(53, val);
      val = "";
      // 烧失量
      if (this.hasValues([40, 41, 42])) {
        val = (((this.getFieldVal(40) + this.getFieldVal(41) - this.getFieldVal(42)) / this.getFieldVal(40)) * 100).toFixed(2);
      }
      this.setFieldVal(43, val);
      val = "";
      // 强度平均值
      if (this.hasValues([45, 46, 47, 48, 49, 50])) {
        val = Math.round(this.sum([45, 46, 47, 48, 49, 50]) / 6);
      }
      this.setFieldVal(51, val);
      val = "";
      // 活性指数
      if (this.hasValues([33, 51])) {
        val = Math.round((this.getFieldVal(51) / this.getFieldVal(33)) * 100);
      }
      this.setFieldVal(52, val);
    },
    sum(indexArr) {
      const form = this.formData;
      let num = 0;
      for (let i = 0; i < indexArr.length; i++) {
        num += form["cell_" + indexArr[i]].resultValue * 1;
      }
      return num;
    },
    hasValues(indexArr, form) {
      if (!form) {
        form = this.formData;
      }
      let res = true;
      for (let i = 0, len = indexArr.length, key; i < len; i++) {
        key = "cell_" + indexArr[i];
        if (!form[key]) {
          console.log(key, "没有在formData中");
          res = false;
          break;
        } else if (form[key].resultValue === undefined || form[key].resultValue.length === 0) {
          console.log(key, "没有输入");
          res = false;
          break;
        }
      }

      return res;
    },
    getFieldVal(x, isText, form) {
      if (!form) {
        form = this.formData;
      }
      if (isText) {
        return form["cell_" + x].resultValue;
      }
      return form["cell_" + x].resultValue * 1;
    },
    setFieldVal(x, val) {
      this.formData["cell_" + x].resultValue = val;
    },
    setData(curKey) {
      this.curKey = curKey;
      let config = {
        form: {},
      };
      for (let key in this.formData) {
        if (key.indexOf(curKey) >= 0) {
          config.form[key] = this.formData[key];
        }
      }
      this.popupConfig = config;
      this.popupVisible = true;
    },
    changeFun(form) {
      console.log(form);
      let res = "";
      switch (this.curKey) {
        case "cell_22":
          if (this.hasValues(form, ["22_p01", "22_p02"])) {
            res = (((this.getFieldVal("22_p01", false, form) - this.getFieldVal("22_p02", false, form)) / this.getFieldVal("22_p01", false, form)) * 100).toFixed(1);
          }
          this.setFieldVal("22_p03", res);
          break;
        case "cell_23":
          if (this.hasValues(form, ["23_p01", "23_p02", "23_p03"])) {
            res = ((this.getFieldVal("23_p01", false, form) / (this.getFieldVal("23_p03", false, form) - this.getFieldVal("23_p02", false, form))) * 100).toFixed(2);
          }
          this.setFieldVal("23_p04", res);
          break;
        case "cell_24":
          if (this.hasValues(form, ["24_p01"])) {
            res = this.getFieldVal("24_p01", false, form).toFixed(1);
          }
          this.setFieldVal("24_p01", res);
          break;
        case "cell_26":
          if (this.hasValues(form, ["26_p01", "26_p02", "26_p03"])) {
            res = (((this.getFieldVal("26_p03", false, form) - this.getFieldVal("26_p01", false, form)) / this.getFieldVal("26_p02", false, form)) * 100).toFixed(2);
          }
          this.setFieldVal("26_p04", res);
          break;
        default:
          break;
      }
    },
    updated(data) {
      const { form } = data;
      for (let key in form) {
        console.log(key);
        this.formData[key] = form[key];
      }
    },
    // 外部获取数据
    getData() {
      let form = JSON.parse(JSON.stringify(this.formData));
      // form.cell_134.resultValue = JSON.stringify(form.cell_134.resultValue)
      // for (const key in form) {
      //   if (typeof form[key].resultValue === "object") {
      //     form[key].resultValue = JSON.stringify(form[key].resultValue);
      //   }
      // }
      return form;
    },
  },
};
</script>
<style lang="scss">
#template1 {
  width: 1200px;
}
</style>
